import { FormInput } from '../../../../../../component/input/InputStyle';
import FormLabel from '../../../../../../component/input/FormLabel.component';
import { ChangeEvent, useState } from 'react';
import useDebounce from '../../../../../../hooks/useDebounce';
import {FormInterfaceFilter} from '../../../../../../core/interfaces/form/Form';
import { VehiclesQueueInterface } from '../../interfaces/VehiclesQueueInterface';


export default function FormFilter({handleSubmitForm}: FormInterfaceFilter<VehiclesQueueInterface>) {

    const debounce = useDebounce(handleSubmitForm, 400);

    const [values, setValues] = useState({
        Veiculo: '',
        Tipo: ''
       });

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { value, name } = event.target;
        setValues({ ...values, [name]: value });
        debounce({ ...values, [name]: value });
    }

    return (
        <>
            <FormLabel title="Veículo" margin='0px 50px 0px 0px' sm={3} md={3} lg={2} >
                <FormInput
                    name="Veiculo"
                    value={values.Veiculo}
                    onChange={handleChange}
                />
            </FormLabel>   
            <FormLabel title="Tipo" sm={3} md={3} lg={2} >
                <FormInput
                    name="Tipo"
                    value={values.Tipo}
                    onChange={handleChange}
                />
            </FormLabel>                   
        </>
    )
}